<template>
    <div v-if="showResetButton" class="-mx-4 -mb-4 mt-auto border-t border-theme-border">
        <button
            class="inline-flex w-full cursor-pointer items-center justify-center border-none bg-transparent px-2 py-3.5 text-xs text-theme-toolbar-icon opacity-65 transition-opacity duration-150 hover:opacity-100"
            @click="confirmReset"
        >
            {{ localizations[lang].resetSettings }}
        </button>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { FONT_SIZE_DEFAULT } from '../../../../src/js/components/partials/Epub/Readium/readium2-styles';

export default {
    name: 'ResetSettingsButton',
    computed: {
        ...mapState(['ui', 'localizations', 'lang', 'userSettings', 'settings']),
        ...mapGetters(['isPdf', 'isEpub', 'isAudiobook']),

        showResetButton() {
            const hasNonDefaultTheme = this.ui.theme !== 'light';
            const hasNonDefaultZoom = this.settings.fontSize !== FONT_SIZE_DEFAULT;

            if (this.isAudiobook) {
                return hasNonDefaultTheme;
            }

            const hasNonDefaultEpubLayout =
                this.userSettings.epub.layout !== null && this.userSettings.epub.layout !== 'single';
            const hasNonDefaultPdfLayout =
                this.userSettings.pdf.layout !== null && this.userSettings.pdf.layout !== 'single';
            const hasNonDefaultFont = this.userSettings.epub.fontFamily !== null;
            const hasNonDefaultLineHeight = this.userSettings.epub.lineHeight !== null;
            const hasNonDefaultMargins = this.userSettings.epub.margins !== null;

            if (this.isPdf) {
                return hasNonDefaultTheme || hasNonDefaultZoom || hasNonDefaultPdfLayout;
            }

            return (
                hasNonDefaultTheme ||
                hasNonDefaultZoom ||
                hasNonDefaultFont ||
                hasNonDefaultLineHeight ||
                hasNonDefaultMargins ||
                hasNonDefaultEpubLayout
            );
        },
    },
    created() {
        this.$bus.$on('confirmResetSettings', this.executeReset);
    },
    beforeDestroy() {
        this.$bus.$off('confirmResetSettings', this.executeReset);
    },
    methods: {
        ...mapMutations(['openConfirmationModal']),
        ...mapActions(['resetUserSettings']),

        confirmReset() {
            this.openConfirmationModal({
                title: this.localizations[this.lang].confirmResetSettings.title,
                message: this.localizations[this.lang].confirmResetSettings.message,
                confirmLabel: this.localizations[this.lang].resetSettings,
                cancelLabel: this.localizations[this.lang].cancel,
                onConfirmAction: 'confirmResetSettings',
            });
        },

        executeReset() {
            this.resetUserSettings();

            // Emit bus events for live viewer updates
            if (this.isPdf) {
                this.$bus.$emit('zoomSelect', { type: 'page-fit' });
            } else if (this.isEpub) {
                this.$bus.$emit('fontFamily', null);
                this.$bus.$emit('lineHeight', null);
                this.$bus.$emit('margins', null);
                this.$bus.$emit('layout', 'single');
                this.$bus.$emit('zoomReset');
            }
        },
    },
};
</script>
